import { useMessageActionContext } from '@/app/providers';
import { DropdownIcon } from '@/assets/images';
import { Dropdown } from '@/components';
import { useChatFeature } from '@/features/chats/chatsRegistry';
import { useMessageActionDropdown } from '@/features/chats/viewmodels';
import PropTypes from 'prop-types';
import './MessageActionDropdown.scss';

const MessageActionDropdown = ({ message, isUser, isSender, position = 'auto', activeChatJid }) => {
   const isSenderFinal = isUser !== undefined ? isUser : isSender;
   const { allowedActions } = useMessageActionContext();
   const isMessageActionEnabled = useChatFeature('message-action');
   const { chatMenuItems } = useMessageActionDropdown({ message, activeChatJid, allowedActions });
   if (!isMessageActionEnabled || chatMenuItems.length === 0) return null;

   const msgType = (message.msgType || message.msgBody?.messageType || 'text').toLowerCase();
   const isReply = !!message.msgBody?.replyTo;
   const isVideoImage = msgType === 'image' || msgType === 'video';

   const dynamicClasses = [
      isSenderFinal ? 'sender-chat' : 'receiver-chat',
      msgType === 'image' ? 'with-image' : '',
      msgType === 'video' ? 'with-video' : '',
      msgType === 'audio' ? 'audio-only' : '',
      msgType === 'text' ? 'text-only' : '',
      msgType === 'location' ? 'location-only' : '',
      msgType === 'file' || msgType === 'document' ? 'document-only' : '',
      isVideoImage ? 'videoimagebubble' : '',
      isReply ? 'reply-bubble' : '',
      message.deleteStatus ? 'custom-deleted-card' : '',
   ]
      .filter(Boolean)
      .join(' ');

   return (
      <div className={`message-quick-actions ${dynamicClasses}`}>
         <Dropdown
            scrollContainerId="conversation-screen"
            icon={
               <i className="ct-flexCenter chevron-icon">
                  <DropdownIcon />
               </i>
            }
            items={chatMenuItems}
            withPadding={false}
            position={position || (isSenderFinal ? 'left' : 'right')}
            buttonClassName="ct-flexCenter dropdown-more-btn"
            dropdownClassName="message-action-dropdown-menu"
         />
      </div>
   );
};

MessageActionDropdown.propTypes = {
   message: PropTypes.object.isRequired,
   isUser: PropTypes.bool,
   isSender: PropTypes.bool,
   position: PropTypes.string,
   activeChatJid: PropTypes.string,
};

export default MessageActionDropdown;
